import { render, staticRenderFns } from "./deletedstudents.vue?vue&type=template&id=d502120e&"
import script from "./deletedstudents.vue?vue&type=script&lang=js&"
export * from "./deletedstudents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports